/** The tabs of the developer page, in the order they show. The open one is deep-linked as `?tab=`. */
export const DEVELOPER_TABS = [
  { value: 'activity', label: 'Activity' },
  { value: 'chat', label: 'Chat' },
  { value: 'schedules', label: 'Schedules' },
  { value: 'usage', label: 'Usage' },
  { value: 'instructions', label: 'Instructions' },
] as const;

export type DeveloperTab = (typeof DEVELOPER_TABS)[number]['value'];

/** What the developer page reads from its URL. No tab means Activity. */
export interface DeveloperSearch {
  tab?: DeveloperTab;
}

/**
 * The tab ids of the ten-tab page, each mapped to the tab that holds its content now, so a link
 * saved before the regroup still opens what it pointed at.
 */
const MOVED_TABS: Record<string, DeveloperTab> = {
  'live-log': 'activity',
  sessions: 'activity',
  disk: 'usage',
  spending: 'usage',
  steps: 'instructions',
  'project-memory': 'instructions',
  schedule: 'schedules',
};

/**
 * Reads `?tab=`: one of the five tabs, an old id moved to its new tab, else no tab, which is Activity.
 * The router keeps search keys a validator leaves out, so an unknown tab is cleared as `undefined`.
 */
export function parseDeveloperSearch(
  raw: Record<string, unknown>,
): DeveloperSearch {
  const tab = raw['tab'];
  if (typeof tab !== 'string') return { tab: undefined };
  const current = DEVELOPER_TABS.find((option) => option.value === tab);
  if (current) return { tab: current.value };
  return { tab: Object.hasOwn(MOVED_TABS, tab) ? MOVED_TABS[tab] : undefined };
}
